export default __webpack_public_path__ + "static/firefox-c50c6709d70903375c65ed14e6445c4c.png";